import React from 'react';
import { inject, observer } from 'mobx-react';
import WorkflowStepBase from './workflow-step-base';
import form from './convert-listing-step-form';
import Cons from '../../../isomorphic/cons';
import Notifications from '../../utils/notification-helper';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import _ from 'lodash';

@inject('appStore')
@observer
export default class ConvertListingStep extends WorkflowStepBase {
    constructor(props) {
        super(props);

        this.form = form();
        this.stepStore = new ConvertListingStepStore(props.appStore);

        if (this.stepStore.isSelectedFileDoubleEnded) {
            this.form.$('isDoubleEnded').value = true;
        }
    }

    handleDoubleEndedOnChange(value) {
        this.form.$('isDoubleEnded').value = value;
    }

    handleConvert(e) {
        e.preventDefault();

        this.form.validate({ showErrors: true }).then(form => {
            if (form.isValid) {
                const formFields = {};
                _.each(this.form.values(), (value, key) => {
                    if (form.fields.get(key).$extra === 'date') {
                        if (!moment.isMoment(value)) {
                            value = moment(value);
                        }

                        formFields[key] = value.isValid() ? value.format() : null;
                    } else {
                        formFields[key] = value;
                    }
                });

                return this.stepStore
                    .convertAndUpdateSelectedFile(formFields)
                    .then(() => {
                        const step = this.props.step;
                        step.state.isComplete = true;
                        step.state.data.convertedDate = moment().format();
                        step.state.data.isDoubleEnded = formFields['isDoubleEnded'];

                        return this.updateStepState(step);
                    })
                    .catch(err => {
                        Notifications.ToastError('Error converting listing.');
                        console.log(err);
                    });
            } else {
                const errorMessages = _.filter(form.errors(), (value, key) => {
                    return !_.isUndefined(value);
                });
                Notifications.ToastError(errorMessages);
            }
        });
    }

    renderIncompleteView(step) {
        const isDoubleEndedDisabled =
            this.props.appStore.tcFileStore.selectedFile.typeOfSale === Cons.saleTypes['Double Ended'];

        return (
            <div className="workflow">
                <div className="row">
                    <form key="convert-listing-step">
                        <div className="col-xs-12 col-sm-12">
                            <div className="form-group">
                                <label htmlFor={this.form.$('isDoubleEnded').id} className="control-label">
                                    {this.form.$('isDoubleEnded').label}
                                </label>
                                &nbsp;
                                <input
                                    {...this.form.$('isDoubleEnded').bind({ value: true })}
                                    type="radio"
                                    disabled={isDoubleEndedDisabled}
                                    checked={this.form.$('isDoubleEnded').value === true}
                                    onChange={this.handleDoubleEndedOnChange.bind(this, true)}
                                />
                                &nbsp;Yes&nbsp;
                                <input
                                    {...this.form.$('isDoubleEnded').bind({ value: false })}
                                    type="radio"
                                    disabled={isDoubleEndedDisabled}
                                    checked={this.form.$('isDoubleEnded').value === false}
                                    onChange={this.handleDoubleEndedOnChange.bind(this, false)}
                                />
                                &nbsp;No&nbsp;
                                {isDoubleEndedDisabled ? <span>(This is a double ended listing)</span> : null}
                                <p className="form-error">{this.form.$('isDoubleEnded').error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-3">
                            <div className="form-group">
                                <label htmlFor={this.form.$('estimatedCloseDate').id} style={{ display: 'block' }}>
                                    {this.form.$('estimatedCloseDate').label}
                                </label>
                                <DatePicker
                                    fixedHeight                                    
                                    className="form-control"
                                    style={{ display: 'inline-block' }}
                                    dateFormat="L"
                                    id={this.form.$('estimatedCloseDate').id}
                                    selected={
                                        this.form.$('estimatedCloseDate').value
                                            ? moment(this.form.$('estimatedCloseDate').value)
                                            : null
                                    }
                                    onChange={this.form.$('estimatedCloseDate').sync}
                                    disabled={this.form.$('estimatedCloseDate').disabled || false}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-3">
                            <div className="form-group">
                                <label htmlFor={this.form.$('fileSubmissionDate').id} style={{ display: 'block' }}>
                                    {this.form.$('fileSubmissionDate').label}
                                </label>
                                <DatePicker
                                    fixedHeight                                    
                                    className="form-control"
                                    style={{ display: 'inline-block' }}
                                    dateFormat="L"
                                    id={this.form.$('fileSubmissionDate').id}
                                    selected={
                                        this.form.$('fileSubmissionDate').value
                                            ? moment(this.form.$('fileSubmissionDate').value)
                                            : null
                                    }
                                    onChange={this.form.$('fileSubmissionDate').sync}
                                    disabled={this.form.$('fileSubmissionDate').disabled || false}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-3"></div>
                        <div className="col-xs-12 col-sm-12">
                            <p className="form-error">{this.form.$(`estimatedCloseDate`).error}</p>
                            <p className="form-error">{this.form.$(`fileSubmissionDate`).error}</p>
                        </div>
                        <div className="col-xs-12 col-sm-12">
                            <button className="btn btn-primary pull-right" onClick={this.handleConvert.bind(this)}>
                                Accept Contract
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    renderCompleteView(step) {
        return <span>Contract Accepted on {moment(step.state.data.convertedDate).format('L LT')}</span>;
    }
}

export class ConvertListingStepStore {
    constructor(appStore) {
        this.appStore = appStore;
    }

    get isSelectedFileDoubleEnded() {
        return this.appStore.tcFileStore.selectedFile.typeOfSale === Cons.saleTypes['Double Ended'];
    }

    convertAndUpdateSelectedFile(formFields) {
        return this.appStore.listingStore.convertSelectedFile().then(result => {
            const fileFields = {
                transactionId: result.transaction.TransactionId,
                status: Cons.fileStatuses['Incomplete'],
                estimatedCloseDate: formFields.estimatedCloseDate,
                fileSubmissionDate: formFields.fileSubmissionDate,
                originatedFromListing: this.appStore.tcFileStore.selectedFile.typeOfSale === Cons.saleTypes['Listing'],
            };

            if (
                formFields['isDoubleEnded'] &&
                this.appStore.tcFileStore.selectedFile.typeOfSale !== Cons.saleTypes['Double Ended']
            ) {
                fileFields.typeOfSale = Cons.saleTypes['Double Ended'];
            } else if (this.appStore.tcFileStore.selectedFile.typeOfSale !== Cons.saleTypes['Double Ended']) {
                fileFields.typeOfSale = Cons.saleTypes['Listing Gone Pending'];
            }

            return this.appStore.tcFileStore.updateSelected(fileFields);
        });
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/convert-listing-step.js